<ion-segment [(ngModel)]="segment" style="margin:8px">
  <ion-segment-button value="sablonok"><ion-label>Sablonok</ion-label></ion-segment-button>
  <ion-segment-button value="varazslok"><ion-label>Varázslók</ion-label></ion-segment-button>
  <ion-segment-button value="iroda"><ion-label>Iroda adatai</ion-label></ion-segment-button>
</ion-segment>

<!-- SABLONOK -->
<div *ngIf="segment === 'sablonok'" class="ion-padding">
  <p>Tölts fel DOCX sablont, benne <code>{{ '${változó}' }}</code> jelölőkkel. Beépített pl. <code>{{ '${ugyazonosito}' }}</code>, <code>{{ '${ugyvednev}' }}</code>; személy pl. <code>{{ '${Ügyfél_nev_1}' }}</code>; minden más egyéni (kitöltendő) változó.</p>
  <p class="kicsi">
    Ismétlődő szakasz: <code>{{ '${#Kedvezmenyezett} … ${/Kedvezmenyezett}' }}</code> (a szerepkör nevével, benne rövid mező pl. <code>{{ '${nev}' }}</code>).
    Számítás: <code>{{ '${szamol kifejezés}' }}</code> törtként (pl. <code>{{ '${szamol hanyad / 6}' }}</code> → 1/12), <code>{{ '${tizedes kifejezés}' }}</code> tizedesként. Műveletek: + − * / és zárójel.
  </p>
  <div class="fejlec-sor">
    <input type="file" accept=".docx" (change)="feltolt($event)" />
    <ion-button fill="outline" size="small" (click)="nyitValtozok()">
      <ion-icon slot="start" name="help-circle-outline"></ion-icon>
      Használható változók
    </ion-button>
  </div>
  <ion-list lines="full">
    <ion-item *ngIf="sablonok.length === 0"><ion-label color="medium">Nincs sablon.</ion-label></ion-item>
    <ion-item *ngFor="let s of sablonok">
      <ion-icon slot="start" name="document-text" color="primary"></ion-icon>
      <ion-label>
        <h3>{{ s.nev }}</h3>
        <p>{{ s.valtozok.length }} változó<span *ngIf="s.kategoria"> · {{ s.kategoria }}</span></p>
      </ion-label>
      <ion-button slot="end" fill="clear" color="success" title="Dokumentum létrehozása (ügy nélkül, űrlapból)" (click)="genNyit(s)"><ion-icon name="sparkles"></ion-icon></ion-button>
      <ion-button slot="end" fill="clear" (click)="konfig(s)"><ion-icon name="settings"></ion-icon></ion-button>
      <ion-button slot="end" fill="clear" (click)="letoltSablon(s)"><ion-icon name="download"></ion-icon></ion-button>
      <ion-button slot="end" fill="clear" color="danger" (click)="torolSablon(s)"><ion-icon name="trash"></ion-icon></ion-button>
    </ion-item>
  </ion-list>
</div>

<!-- VARÁZSLÓK -->
<div *ngIf="segment === 'varazslok'" class="ion-padding">
  <ion-button (click)="ujVarazslo()"><ion-icon slot="start" name="add"></ion-icon>Új varázsló</ion-button>
  <p>A varázsló sablonok lánca – egy ügyön egyszerre legenerálja az összeset (pl. megbízási szerződés + meghatalmazás).</p>
  <ion-list lines="full">
    <ion-item *ngIf="varazslok.length === 0"><ion-label color="medium">Nincs varázsló.</ion-label></ion-item>
    <ion-item *ngFor="let v of varazslok">
      <ion-icon slot="start" name="albums" color="primary"></ion-icon>
      <ion-label><h3>{{ v.nev }}</h3><p>{{ v.leiras }}</p></ion-label>
      <ion-button slot="end" fill="clear" (click)="szerkVarazslo(v)"><ion-icon name="create"></ion-icon></ion-button>
      <ion-button slot="end" fill="clear" color="danger" (click)="torolVarazslo(v)"><ion-icon name="trash"></ion-icon></ion-button>
    </ion-item>
  </ion-list>
</div>

<!-- IRODA ADATAI -->
<div *ngIf="segment === 'iroda'" class="ion-padding">
  <p>Ezek az adatok töltik fel a beépített ügyvéd-változókat a sablonokban (<code>{{ '${ugyvednev}' }}</code>, <code>{{ '${kasz}' }}</code>…).</p>
  <ion-list>
    <ion-item *ngFor="let m of irodaMezok">
      <ion-input [label]="m.l" labelPlacement="stacked" [(ngModel)]="iroda[m.k]"></ion-input>
    </ion-item>
  </ion-list>
  <ion-button expand="block" (click)="mentIroda()">Mentés</ion-button>
</div>

<!-- SABLON KONFIG MODAL -->
<ion-modal #sablonModal>
  <ng-template>
    <ion-header><ion-toolbar color="primary">
      <ion-title>Sablon beállítása</ion-title>
      <ion-buttons slot="end"><ion-button (click)="sablonModal.dismiss()">Mégse</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="szerk">
      <ion-list>
        <ion-item><ion-input label="Sablon neve" labelPlacement="stacked" [(ngModel)]="szerk.nev"></ion-input></ion-item>
        <ion-item><ion-input label="Kategória" labelPlacement="stacked" [(ngModel)]="szerk.kategoria"></ion-input></ion-item>
      </ion-list>

      <!-- Új verzió: lecseréli a sablon DOCX-fájlját és újra-észleli a változókat (egyéni beállítások megmaradnak). -->
      <input #verzioInput type="file" accept=".docx" hidden (change)="ujVerzio($event)" />
      <ion-button expand="block" fill="outline" class="ion-margin-top" (click)="verzioInput.click()">
        <ion-icon name="cloud-upload-outline" slot="start"></ion-icon> Új verzió feltöltése (DOCX csere)
      </ion-button>

      <ion-list-header><ion-label>Változók</ion-label></ion-list-header>
      <ion-item *ngIf="szerk.valtozok.length === 0"><ion-label color="medium">Nem találtam változót a sablonban.</ion-label></ion-item>
      <div *ngFor="let v of szerk.valtozok" class="valtozo">
        <ion-item lines="none">
          <ion-badge slot="start" [color]="forrasSzin(v.forras)">{{ forrasCimke(v.forras) }}</ion-badge>
          <ion-label><code>{{ '${' + v.tag + '}' }}</code></ion-label>
        </ion-item>
        <!-- egyéni változónál konfigurálható a kérdés címke + típus -->
        <div *ngIf="v.forras === 'egyeni'" class="ion-padding-start">
          <ion-item><ion-input label="Kérdés (címke)" labelPlacement="stacked" [(ngModel)]="v.label"></ion-input></ion-item>
          <ion-item>
            <ion-select label="Típus" labelPlacement="stacked" [(ngModel)]="v.tipus" interface="popover">
              <ion-select-option value="szoveg">Szöveg</ion-select-option>
              <ion-select-option value="legordulo">Legördülő</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item *ngIf="v.tipus === 'legordulo'">
            <ion-input label="Opciók (vesszővel)" labelPlacement="stacked" [value]="(v.opciok || []).join(', ')" (ionInput)="opcioSzerk(v, $event.target.value)"></ion-input>
          </ion-item>
        </div>
      </div>
      <ion-button expand="block" class="ion-margin-top" (click)="mentSablon()">Mentés</ion-button>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- VÁLTOZÓ-KATALÓGUS MODAL -->
<ion-modal #valtozoModal>
  <ng-template>
    <ion-header><ion-toolbar color="primary">
      <ion-title>Használható változók</ion-title>
      <ion-buttons slot="end"><ion-button (click)="valtozoModal.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding">
      <ion-item lines="full">
        <ion-select label="Ügy (a konkrét értékekhez)" labelPlacement="stacked" interface="alert"
                    [(ngModel)]="valtozoUgyId" (ionChange)="valtozoKatalogusBetolt()">
          <ion-select-option value="">— Nincs (csak leírás + dátum/iroda) —</ion-select-option>
          <ion-select-option *ngFor="let u of ugyek" [value]="u.id">{{ u.ugyazonosito }} – {{ u.leiras }}</ion-select-option>
        </ion-select>
      </ion-item>
      <p class="kicsi">Kattints egy <code>{{ '${tag}' }}</code>-re a vágólapra másoláshoz. Az „érték" azt mutatja, mit venne fel generáláskor.</p>

      <div *ngIf="valtozoBetolt" class="kozepre"><ion-spinner></ion-spinner></div>

      <ng-container *ngIf="!valtozoBetolt && valtozoKatalogus">
        <div *ngFor="let cs of valtozoKatalogus.csoportok" class="valtozo-csoport">
          <ion-list-header><ion-label>{{ cs.nev }}</ion-label></ion-list-header>
          <p *ngIf="cs.megjegyzes" class="kicsi ion-padding-horizontal">{{ cs.megjegyzes }}</p>
          <ion-item *ngFor="let v of cs.valtozok" button detail="false" (click)="masolTag(v.tag)">
            <ion-label>
              <code>{{ '${' + v.tag + '}' }}</code>
              <p>{{ v.leiras }}</p>
            </ion-label>
            <div slot="end" class="ertek">
              <span *ngIf="v.ertek !== null && v.ertek !== ''" class="ertek-van">{{ v.ertek }}</span>
              <span *ngIf="v.ertek === ''" class="ertek-ures">(üres)</span>
              <span *ngIf="v.ertek === null" class="ertek-ures">ügyfüggő</span>
            </div>
          </ion-item>
        </div>
      </ng-container>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- ÜGY NÉLKÜLI GENERÁLÁS MODAL (űrlapból) -->
<ion-modal #generalModal>
  <ng-template>
    <ion-header><ion-toolbar color="primary">
      <ion-title>Dokumentum létrehozása</ion-title>
      <ion-buttons slot="end"><ion-button (click)="generalModal.dismiss()">Mégse</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="gen">
      <h2 style="margin-top:0">{{ gen.sablon.nev }}</h2>
      <ion-note color="medium" style="display:block">Ügy nélküli generálás: töltsd ki a mezőket. A dátum és az iroda-adatok automatikusak.</ion-note>

      <!-- Kézzel kitöltendő (egyéni) mezők -->
      <ion-list *ngIf="gen.mezok.length">
        <ion-list-header><ion-label>Kitöltendő mezők</ion-label></ion-list-header>
        <ion-item *ngFor="let mez of gen.mezok">
          <ion-select *ngIf="mez.tipus === 'legordulo'" [label]="mez.label || mez.tag" labelPlacement="stacked" [(ngModel)]="gen.ertekek[mez.tag]" interface="popover">
            <ion-select-option *ngFor="let o of mez.opciok" [value]="o">{{ o }}</ion-select-option>
          </ion-select>
          <ion-input *ngIf="mez.tipus !== 'legordulo'" [label]="mez.label || mez.tag" labelPlacement="stacked" [(ngModel)]="gen.ertekek[mez.tag]"></ion-input>
        </ion-item>
      </ion-list>

      <!-- Személyek (a személy-/loop-változókhoz) – a nyilvántartásból, JÜB-ből behúzott személyek is -->
      <ion-list-header *ngIf="gen.szerepek.length"><ion-label>Személyek</ion-label></ion-list-header>
      <ng-container *ngIf="gen.szerepek.length">
        <ion-list lines="full" *ngIf="gen.szereplok.length">
          <ion-item *ngFor="let s of gen.szereplok; let i = index">
            <ion-icon slot="start" [name]="s.uj ? 'person-add' : 'person'" color="primary"></ion-icon>
            <ion-label><h3>{{ s.nev }} <ion-badge *ngIf="s.uj" [color]="s.uj.tarol ? 'success' : 'medium'">{{ s.uj.tarol ? 'új – mentésre' : 'új – csak ehhez' }}</ion-badge></h3><p>{{ s.szerep }}</p></ion-label>
            <ion-button slot="end" fill="clear" color="danger" (click)="genSzereploTorol(i)"><ion-icon name="trash"></ion-icon></ion-button>
          </ion-item>
        </ion-list>
        <ion-item>
          <ion-select label="Szerepkör" labelPlacement="stacked" [(ngModel)]="genUjSzerep" interface="popover">
            <ion-select-option *ngFor="let r of gen.szerepek" [value]="r">{{ r }}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-searchbar [(ngModel)]="genSzemelyKereso" placeholder="Személy keresése a nyilvántartásból (JÜB-ből is)…"></ion-searchbar>
        <ion-list *ngIf="genSzemelyKereso.trim()" lines="full" style="max-height:220px;overflow:auto">
          <ion-item button *ngFor="let s of genSzemelyTalalatok" (click)="genValasztSzemely(s)">
            <ion-icon slot="start" name="person-add" color="primary"></ion-icon>
            <ion-label><h3>{{ s.nev }}</h3><p><span *ngIf="s.szuletesi_ido">{{ s.szuletesi_ido }}</span><span *ngIf="s.szuletesi_hely"> · {{ s.szuletesi_hely }}</span></p></ion-label>
          </ion-item>
          <ion-item *ngIf="genSzemelyTalalatok.length === 0"><ion-label color="medium">Nincs találat.</ion-label></ion-item>
        </ion-list>

        <!-- Nincs a nyilvántartásban? Vidd fel kézzel; opcionálisan a generáláskor el is mentődik. -->
        <ion-button fill="clear" size="small" (click)="genUjMod = !genUjMod">
          <ion-icon slot="start" [name]="genUjMod ? 'chevron-up' : 'add-circle'"></ion-icon>
          {{ genUjMod ? 'Új személy bezárása' : 'Nincs a nyilvántartásban? Új személy felvétele' }}
        </ion-button>
        <div *ngIf="genUjMod" class="ion-padding-start" style="border-left:2px solid var(--ion-color-light-shade)">
          <ion-item><ion-input label="Név *" labelPlacement="stacked" [(ngModel)]="genUj.nev"></ion-input></ion-item>
          <ion-row>
            <ion-col><ion-item><ion-input label="Születési hely" labelPlacement="stacked" [(ngModel)]="genUj.szuletesi_hely"></ion-input></ion-item></ion-col>
            <ion-col><ion-item><ion-input type="date" label="Születési idő" labelPlacement="stacked" [(ngModel)]="genUj.szuletesi_ido"></ion-input></ion-item></ion-col>
          </ion-row>
          <ion-item><ion-input label="Anyja neve" labelPlacement="stacked" [(ngModel)]="genUj.anyja_neve"></ion-input></ion-item>
          <ion-item><ion-input label="Lakcím" labelPlacement="stacked" [(ngModel)]="genUj.lakcim"></ion-input></ion-item>
          <ion-row>
            <ion-col><ion-item><ion-input label="Személyi szám" labelPlacement="stacked" [(ngModel)]="genUj.szemelyi_szam"></ion-input></ion-item></ion-col>
            <ion-col><ion-item><ion-input label="Adóazonosító" labelPlacement="stacked" [(ngModel)]="genUj.adoazonosito"></ion-input></ion-item></ion-col>
          </ion-row>
          <ion-item lines="none">
            <ion-checkbox slot="start" [(ngModel)]="genUjTarol"></ion-checkbox>
            <ion-label class="ion-text-wrap">Mentés a nyilvántartásba (legközelebb kereshető lesz)</ion-label>
          </ion-item>
          <ion-button expand="block" fill="outline" size="small" (click)="genUjSzemelyHozzaad()"><ion-icon slot="start" name="checkmark"></ion-icon>Hozzáadás ({{ genUjSzerep }})</ion-button>
        </div>
      </ng-container>

      <ion-item lines="none" class="ion-margin-top">
        <ion-checkbox slot="start" [(ngModel)]="gen.pdf"></ion-checkbox>
        <ion-label>PDF-ként (különben szerkeszthető DOCX)</ion-label>
      </ion-item>

      <ion-item lines="none" *ngIf="eszignoElerheto && gen.pdf">
        <ion-checkbox slot="start" [(ngModel)]="gen.alair"></ion-checkbox>
        <ion-label class="ion-text-wrap">Aláírás e-Szignóval<br /><small style="color:var(--ion-color-medium)">A generált PDF-et a token/kártya tanúsítványoddal írja alá (PIN-bekérés)</small></ion-label>
      </ion-item>

      <ion-button expand="block" [disabled]="genKeszites" (click)="genGeneral()">
        <ion-spinner *ngIf="genKeszites" slot="start" name="crescent"></ion-spinner>
        Dokumentum létrehozása
      </ion-button>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- VARÁZSLÓ MODAL -->
<ion-modal #varazsloModal>
  <ng-template>
    <ion-header><ion-toolbar color="primary">
      <ion-title>{{ varSzerk?.id ? 'Varázsló szerkesztése' : 'Új varázsló' }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="varazsloModal.dismiss()">Mégse</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="varSzerk">
      <ion-list>
        <ion-item><ion-input label="Név" labelPlacement="stacked" [(ngModel)]="varSzerk.nev"></ion-input></ion-item>
        <ion-item><ion-input label="Leírás" labelPlacement="stacked" [(ngModel)]="varSzerk.leiras"></ion-input></ion-item>
        <ion-item>
          <ion-select label="Sablonok (sorrendben)" labelPlacement="stacked" [(ngModel)]="varSzerk.sablon_idk" [multiple]="true" interface="alert">
            <ion-select-option *ngFor="let s of sablonok" [value]="s.id">{{ s.nev }}</ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>
      <ion-button expand="block" (click)="mentVarazslo()">Mentés</ion-button>
    </ion-content>
  </ng-template>
</ion-modal>
